// MaintenanceOperationsList.js
import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  FunctionField,
  EditButton,
  Pagination,
  CreateButton,
  TopToolbar,
  useRecordContext,
} from 'react-admin';
import { Chip } from '@mui/material';

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="New Maintenance Job" />
  </TopToolbar>
);

const StatusField = ({ source }) => {
  // const record = React.useContext(RecordContext);
  const record = useRecordContext();
  if (!record) return null;
  
  const statusColors = {
    pending: 'default',
    uploaded: 'info',
    validated: 'warning',
    processed: 'success',
    failed: 'error',
    rolled_back: 'default',        // Added
    rollback_failed: 'error',      // Added
  };
  
  return (
    <Chip 
      label={record[source].toUpperCase()} 
      color={statusColors[record[source]] || 'default'}
      size="small"
    />
  );
};

const MaintenanceOperationsList = (props) => {
  return (
    <List 
      {...props} 
      title="Maintenance Jobs"
      actions={<ListActions />}
      sort={{ field: 'created_at', order: 'DESC' }}
    >
      <Pagination />
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="id" label="Job #" />
        <DateField source="created_at" label="Created" showTime />
        <TextField source="created_by" label="Created By" />
        <FunctionField
          label="Status"
          render={record => <StatusField source="status" />}
        />
        <TextField source="alumni_class_name" label="Alumni Class" />
        <DateField source="processed_at" label="Processed" showTime />
        <EditButton />
      </Datagrid>
    </List>
  );
};

export default MaintenanceOperationsList;